import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const AmrKpiDtoSchema = z.object({
  marketMin: z.number().nullable(),
  marketMedian: z.number().nullable(),
  marketMax: z.number().nullable(),
  currentValue: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export const GetAmrKpiRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

export const GetAmrKpiResponseDtoSchema = AmrKpiDtoSchema;

export type AmrKpiDto = z.infer<typeof AmrKpiDtoSchema>;

export type GetAmrKpiRequestDto = z.infer<typeof GetAmrKpiRequestDtoSchema>;

export type GetAmrKpiResponseDto = z.infer<typeof GetAmrKpiResponseDtoSchema>;

export const getAmrKpi = async (
  params: GetAmrKpiRequestDto,
  config?: AxiosRequestConfig<GetAmrKpiRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/amr-kpi`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetAmrKpiResponseDtoSchema));
};
